import { render } from "./link.vue?vue&type=template&id=3b89b343&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"

import "./link.vue?vue&type=style&index=0&id=3b89b343&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b89b343"],['__file',"src/views/vab/form/link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b89b343"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b89b343', __exports__)) {
    console.log('reload')
    api.reload('3b89b343', __exports__)
  }
  
  module.hot.accept("./link.vue?vue&type=template&id=3b89b343&scoped=true", () => {
    console.log('re-render')
    api.rerender('3b89b343', render)
  })

}


export default __exports__